import React from "react";
import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/Logo";

const SIDE_IMG = "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxjYXJkYm9hcmQlMjBwYWNrYWdlJTIwZGVsaXZlcnklMjBwYXJjZWwlMjBoYW5kfGVufDB8fHx8MTc5MDQ5NjY0Nnww&ixlib=rb-4.1.0&q=85";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="flex flex-col justify-center px-5 sm:px-10 py-10 max-w-lg w-full mx-auto">
        <Link to="/" className="flex items-center gap-2 mb-8" data-testid="auth-logo">
          <BrandLogo />
        </Link>
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">{title}</h1>
        {subtitle && <p className="mt-2 text-slate-500">{subtitle}</p>}
        <div className="mt-7">{children}</div>
        {footer && <div className="mt-6 text-sm text-slate-500 text-center">{footer}</div>}
      </div>
      <div className="hidden lg:block relative">
        <img src={SIDE_IMG} alt="Package hand-over" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-primary/40" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <h2 className="text-3xl font-bold">Travel. Connect. Deliver.</h2>
          <p className="mt-2 text-white/85">Join a community turning journeys into deliveries.</p>
        </div>
      </div>
    </div>
  );
}
